import { useSelector } from "react-redux";
import { Translate } from "../../../Enums/Tranlate";

const CardItem = ({ item, index }) => {
	const lang = useSelector((state) => state.auth.lang);
	return (
		<tr key={index} className="text-center">
			<td className="text-wrap-mode">{item.client_name}</td>
			<td className="text-wrap-mode">{item.client_email}</td>
			<td className="text-wrap-mode">{item.client_phone}</td>
			<td className="text-wrap-mode">
				{item?.price?.toFixed(3)} {Translate[lang].kwd}
			</td>
			<td className="text-wrap-mode">{item.TrackID}</td>
			<td className="text-wrap-mode">{item.TranID}</td>
			<td className="text-wrap-mode">{item.PaymentID}</td>
			<td className="text-wrap-mode">{item.invoice_id}</td>
			<td className="text-wrap-mode">{item?.createdAt?.split("T")[0]}</td>
			<td className="text-wrap-mode">{item.payment_type}</td>
		</tr>
	);
};
export default CardItem;
